export default "__VITE_ASSET__D56SZwmg__"